export default {
  campaign: () => import("/azp/_work/1/s/majority-com/layouts/campaign.vue").then(m => m.default || m),
  community: () => import("/azp/_work/1/s/majority-com/layouts/community.vue").then(m => m.default || m),
  default: () => import("/azp/_work/1/s/majority-com/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/azp/_work/1/s/majority-com/layouts/empty.vue").then(m => m.default || m),
  external: () => import("/azp/_work/1/s/majority-com/layouts/external.vue").then(m => m.default || m),
  legal: () => import("/azp/_work/1/s/majority-com/layouts/legal.vue").then(m => m.default || m),
  link: () => import("/azp/_work/1/s/majority-com/layouts/link.vue").then(m => m.default || m),
  press: () => import("/azp/_work/1/s/majority-com/layouts/press.vue").then(m => m.default || m),
  presssingle: () => import("/azp/_work/1/s/majority-com/layouts/presssingle.vue").then(m => m.default || m)
}